import { NavLink, Outlet } from 'react-router-dom'
import { useI18n } from '../i18n/I18nProvider'
import { useSession } from '../session/SessionProvider'

export function LanguageToggle() {
  const { lang, setLang, t } = useI18n()

  return (
    <button
      type="button"
      className="lang-toggle"
      // The label names the language you would switch TO, which is the only thing a reader who
      // cannot read the current one can act on.
      aria-label={t('lang.label')}
      onClick={() => setLang(lang === 'zh' ? 'en' : 'zh')}
    >
      {t('lang.switch')}
    </button>
  )
}

export function Shell({ children }: { children: React.ReactNode }) {
  const { t } = useI18n()

  return (
    <div className="shell">
      <header className="shell-header">
        <span className="brand">{t('app.name')}</span>
        <LanguageToggle />
      </header>
      <main className="shell-main">{children}</main>
    </div>
  )
}

/** The signed-in frame: brand, navigation, language, sign out. */
export function AppLayout() {
  const { t } = useI18n()
  const { signOut, account } = useSession()

  return (
    <div className="shell">
      <header className="shell-header">
        <span className="brand">{t('app.name')}</span>

        <nav className="nav">
          <NavLink to="/matching">{t('nav.matching')}</NavLink>
          <NavLink to="/matches">{t('nav.matches')}</NavLink>
          <NavLink to="/invitations">{t('nav.invitations')}</NavLink>
          <NavLink to="/connection">{t('nav.connection')}</NavLink>
          <NavLink to="/profile">{t('nav.profile')}</NavLink>
          <NavLink to="/photo">{t('nav.photo')}</NavLink>
          <NavLink to="/contact">{t('nav.contact')}</NavLink>
          <NavLink to="/preferences">{t('nav.preferences')}</NavLink>
          <NavLink to="/account">{t('nav.account')}</NavLink>
          {account?.isAdmin ? <NavLink to="/admin">{t('nav.admin')}</NavLink> : null}
        </nav>

        <div className="header-actions">
          <LanguageToggle />
          <button type="button" className="link-button" onClick={() => void signOut()}>
            {t('nav.signOut')}
          </button>
        </div>
      </header>

      <main className="shell-main">
        <Outlet />
      </main>
    </div>
  )
}
